import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx } from "vue"

import {DropDownButtonComponent} from "@syncfusion/ej2-vue-splitbuttons";
import {computed} from "vue";
import SogDropDownButtonItem from "@/shared/ui/types/SogDropDownButtonItem";
import {SogDropDownButtonType} from "@/shared/ui/types/SogDropDownButtonType";

interface Props {
  mdiIcon?: string
  items?: SogDropDownButtonItem[]
  type?: SogDropDownButtonType
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SogDropDownButton',
  props: {
    mdiIcon: { default: "" },
    items: { default: undefined },
    type: { default: SogDropDownButtonType.Default }
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const _emit = __emit

/*
const  items=[
  {
    text: 'Cut'
  },
  {
    text: 'Copy'
  },
  {
    text: 'Paste'
  }]
*/

const _mdiIconStyle = computed(() => {
  return ""
  return "margin-right: 3px"
  //return "margin-right: 30px"
})


const _mdiIcon = computed(() => {
  if (props.mdiIcon)
    return props.mdiIcon
  return undefined
})

const _cssClass = computed(() => {
  switch (props.type) {
    case SogDropDownButtonType.Appbar:
      return "e-inherit e-appbar-menu";
    case SogDropDownButtonType.Card:
      return "e-card-btn";
    default:
      return ""
  }
})

function onSelect(args: any) {
  _emit("select", args.item)
}



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(_unref(DropDownButtonComponent), {
    items: props.items,
    select: onSelect,
    "css-class": _cssClass.value
  }, {
    default: _withCtx(() => [
      (_mdiIcon.value)
        ? (_openBlock(), _createBlock(_component_v_icon, {
            key: 0,
            icon: _mdiIcon.value,
            style: _normalizeStyle(_mdiIconStyle.value),
            class: "sog-button-mdi-icon"
          }, null, 8, ["icon", "style"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["items", "css-class"]))
}
}

})